import { SvgIcon, SvgIconProps } from '@mui/material';

export const FoodIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 -960 960 960'
      width='24'
      fill='none'
      {...props}
    >
      <path d='M556.578-403.421q-29.307-46.385-85.583-64.289-56.276-17.904-116.497-17.904-60.036 0-116.902 17.904-56.865 17.904-85.404 64.289h404.386ZM78.54-347.461q0-94.692 85.154-144.402 85.154-49.711 190.691-49.711 105.538 0 190.692 49.711 85.153 49.71 85.153 144.402H78.54Zm0 139.191v-55.96h551.69v55.96H78.54ZM706.192-68.078v-55.96h58.423l55.192-544.231H455.039l-6.885-55.96h188.269v-158.385h55.96v158.385H881.46l-61.395 609.938q-2.537 20.142-17.829 33.177-15.292 13.036-35.737 13.036h-60.307Zm0-55.96h58.423-58.423Zm-595.25 55.96q-13.825 0-23.113-9.288-9.289-9.289-9.289-23.019v-23.653h551.69v23.653q0 13.73-9.288 23.019-9.288 9.288-23.113 9.288H110.942Zm243.443-335.343Z' />
    </SvgIcon>
  );
};
